import React, { useEffect, useRef } from "react";
import { Form, InputNumber } from "antd";
const { Item } = Form;

const InputNumnber = (props) => {
  const {
    id,
    placeholder,
    name,
    label,
    required,
    value,
    onChangeHandler,
    max,
    min,
    className,
    focus,
    disabled,
  } = props;

  const myRef = useRef(className || "");

  useEffect(() => {
    if (focus) myRef.current.focus();
  }, [focus]);

  return (
    <div>
      <Item
        key={id}
        name={name}
        label={label}
        size="true"
        rules={[
          {
            required: required,
          },
        ]}
      >
        <InputNumber
          className={`form-input-element ${className}`}
          size="small"
          onChange={(value) => onChangeHandler(value, id)}
          value={value}
          max={max || null}
          min={min || null}
          placeholder={placeholder}
          autoComplete={"off"}
          ref={myRef}
          disabled={disabled || false}
        />
      </Item>
    </div>
  );
};

export default InputNumnber;
